import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomModal,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
} from '../../../../../components'
import { errorHandler } from '../../../../../services/util/error.service'
import * as RetornoHttp from '../../../../../services/api/https/deliveries/retorno.http'
import {
  buildFaltaQuantityInputState,
  getFaltaInputLabels,
  getFaltaQuantityConfig,
  getFaltaQuantityValueFromInputs,
} from './falta-volume-and-units.helper'

function ModalAjusteFalta({
  falta,
  onSuccess,
  onModalClose,
  onError,
  ignorarStatusEntrega = false,
  modalContentClassName = '',
  modalStyle = null,
}) {
  if (!falta) return null

  // Vars
  const { qte_adjusted, adjust_justification, missing_product_id } = falta
  const initialQuantityState = buildFaltaQuantityInputState(falta, qte_adjusted)
  const { canUseFractionedInput } = getFaltaQuantityConfig(falta)
  const { volumeLabel, unitsLabel } = getFaltaInputLabels(falta)

  // Hooks
  const [qte, setQte] = useState(initialQuantityState.quantityValue)
  const [volumeValue, setVolumeValue] = useState(initialQuantityState.volumeValue)
  const [unitsValue, setUnitsValue] = useState(initialQuantityState.unitsValue)
  const [justification, setJustification] = useState(
    adjust_justification ? adjust_justification : '',
  )

  useEffect(() => {
    const nextQuantityState = buildFaltaQuantityInputState(falta, qte_adjusted)

    setQte(nextQuantityState.quantityValue)
    setVolumeValue(nextQuantityState.volumeValue)
    setUnitsValue(nextQuantityState.unitsValue)
    setJustification(adjust_justification ? adjust_justification : '')
  }, [falta, qte_adjusted, adjust_justification])

  const onQuantityChange = (field, value) => {
    const nextVolumeValue = field === 'volume' ? value : volumeValue
    const nextUnitsValue = field === 'units' ? value : unitsValue

    setVolumeValue(nextVolumeValue)
    setUnitsValue(nextUnitsValue)
    setQte(getFaltaQuantityValueFromInputs(falta, nextVolumeValue, nextUnitsValue))
  }

  // Events
  const onBtnSalvarClicked = async () => {
    if (justification.trim().length <= 5) {
      onError('A justificativa deve conter pelo menos 5 caracteres')
      return
    }

    try {
      const fetched_missing_products = await RetornoHttp.putMissingProductQteAdjusted({
        qte_adjusted: Number(qte),
        adjust_justification: justification,
        missing_product_id,
        ignorar_status_entrega: ignorarStatusEntrega,
      })
      onSuccess(fetched_missing_products.find(f => f.missing_product_id === missing_product_id))
    } catch (e) {
      onError(errorHandler(e))
    }
  }

  // Render
  return (
    <CustomModal
      header="Ajuste da Quantidade da Ocorrência"
      isVisible={true}
      onClose={onModalClose}
      width={modalStyle ? 'min(720px, 94vw)' : null}
      style={modalStyle}
    >
      <form className={`${modalContentClassName} ajuste-falta-modal__content`}>
        <div className="ajuste-falta-modal__summary">
          <div className="ajuste-falta-modal__summary-item">
            <span>Produto</span>
            <strong>
              {falta.product_code ? `${falta.product_code} - ` : ''}
              {falta.product_name || '-'}
            </strong>
          </div>
          <div className="ajuste-falta-modal__summary-item">
            <span>Motivo</span>
            <strong>
              {falta.reason_sigla ? `(${falta.reason_sigla}) ` : ''}
              {falta.reason || '-'}
            </strong>
          </div>
        </div>

        <div className="ajuste-falta-modal__fields">
          <div className="ajuste-falta-modal__field">
            {canUseFractionedInput ? (
              <InputNumeroInteiro
                label={volumeLabel}
                marginTop={0}
                value={volumeValue}
                onChange={value => onQuantityChange('volume', value)}
              />
            ) : (
              <InputNumeroDecimal
                label={volumeLabel}
                marginTop={0}
                value={volumeValue}
                onChange={value => onQuantityChange('volume', value)}
              />
            )}
          </div>
          <div className="ajuste-falta-modal__field">
            <InputNumeroInteiro
              label={unitsLabel}
              marginTop={0}
              value={unitsValue}
              onChange={value => onQuantityChange('units', value)}
              disabled={!canUseFractionedInput}
            />
          </div>
        </div>

        <div className="ajuste-falta-modal__field">
          <InputText
            label="Justificativa :"
            marginTop={0}
            value={justification}
            onChange={value => setJustification(value)}
          />
        </div>

        <div className="ajuste-falta-modal__footer">
          <Btn minWidth={null} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalAjusteFalta
